import { computed } from 'vue';

export function useChannelIcon(inbox) {
  const channelTypeIconMap = {
    'Channel::Api': 'i-aidexa-api',
    'Channel::Email': 'i-aidexa-mail',
    'Channel::FacebookPage': 'i-aidexa-messenger',
    'Channel::Line': 'i-aidexa-line',
    'Channel::Sms': 'i-aidexa-sms',
    'Channel::Telegram': 'i-aidexa-telegram',
    'Channel::TwilioSms': 'i-aidexa-sms',
    'Channel::TwitterProfile': 'i-ri-twitter-x-fill',
    'Channel::WebWidget': 'i-aidexa-website',
    'Channel::Whatsapp': 'i-aidexa-whatsapp',
    'Channel::Instagram': 'i-aidexa-instagram',
    'Channel::Voice': 'i-ri-phone-fill',
  };

  const providerIconMap = {
    microsoft: 'i-aidexa-outlook',
    google: 'i-aidexa-gmail',
  };

  const channelIcon = computed(() => {
    const inboxDetails = inbox.value || inbox;
    const type = inboxDetails.channel_type;
    let icon = channelTypeIconMap[type];

    if (type === 'Channel::Email' && inboxDetails.provider) {
      if (Object.keys(providerIconMap).includes(inboxDetails.provider)) {
        icon = providerIconMap[inboxDetails.provider];
      }
    }

    // Special case for Twilio whatsapp
    if (type === 'Channel::TwilioSms' && inboxDetails.medium === 'whatsapp') {
      icon = 'i-aidexa-whatsapp';
    }

    return icon ?? 'i-ri-global-fill';
  });

  return channelIcon;
}
